"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const get_1 = __importDefault(require("lodash-es/get"));
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const react_native_1 = require("react-native");
const ShimmerRenderer = ({ type, props }) => {
    const widgetRegistry = SharedPropsService_1.default.getPropsValue('widgetRegistry');
    const Widget = (0, get_1.default)(widgetRegistry, `${type}`, null);
    const WidgetToRender = Widget && Widget.Component
        ? Widget.Component
        : null;
    return (react_1.default.createElement(react_native_1.View, { style: {
            marginTop: 16,
            marginHorizontal: 16,
        } }, WidgetToRender ? (react_1.default.createElement(WidgetToRender, Object.assign({}, Object.assign(Object.assign({}, Widget.Mock.args), props)))) : null));
};
exports.default = ShimmerRenderer;
//# sourceMappingURL=ShimmerRenderer.js.map